import React, { useState, useCallback, useEffect } from "react";
import store from "@/redux-store";
import { addClient } from "@/Services/Clients";
import {
	acceptPendingOpportunitySharedWithPartner,
	rejectPendingOpportunitySharedWithPartner,
	getPendingOpportunitySharedWithPartnerRequest,
	checkConflictForPendingOpportunityShareWithPartner
} from "@/Services/Opportunity";
import ZViewOpportunityRequestModal from "@/V2Components/UI/organisms/ZViewOpportunityRequest/ZViewOpportunityRequestModal";
import {
	AddClientRequest,
	ChildEntityHydrationParams
} from "@/Contracts";
import { ZMessage } from "@molecules";
import { IPendingOpportunityModal } from "./interface";
import NotificationFeedActionCreators from "@/Actions/Others/NotificationFeed";

const PendingOpportunitiesModal: React.FC<IPendingOpportunityModal> = ({
	id,
	onClose
}) => {
	const state = store.getState();
	const { userData } = {
		userData: state.user.userData
	};
	const [viewOpportunityRequestModalId, setViewOpportunityRequestModalId] =
		useState<string | null>(null);
	const createClient = useCallback(
		async (addClientRequest: AddClientRequest) => {
			addClientRequest.owner_user_id = userData.id;
			return await addClient(addClientRequest);
		},
		[]
	);
	const acceptPendingOpportunityRequest = async (clientId: string) => {
		const acceptedPendingOpportunity =
			await acceptPendingOpportunitySharedWithPartner(
				viewOpportunityRequestModalId ?? "",
				clientId,
				[
					ChildEntityHydrationParams.CLIENT_COMPANIES_NAME,
					ChildEntityHydrationParams.OPPORTUNITY_ACTION_STATUS,
					ChildEntityHydrationParams.VENDORS_ALL,
					ChildEntityHydrationParams.VENDOR_OPPORTUNITIES_INSIGHTS
				]
			);
		ZMessage.success(
			`${acceptedPendingOpportunity.name} Successfully Accepted`
		);
		refreshNotificationsFeed();
		onClose();
		return acceptedPendingOpportunity;
	};
	const rejectPendingOpportunityRequest = async (
		opportunityId: string,
		clientId: string
	) => {
		const rejectedPendingOpportunity =
			await rejectPendingOpportunitySharedWithPartner(
				opportunityId,
				clientId
			);
		ZMessage.success(
			`${rejectedPendingOpportunity.name} Successfully Rejected`
		);
		refreshNotificationsFeed();
		return rejectedPendingOpportunity;
	};
	useEffect(() => {
		setViewOpportunityRequestModalId(id);
	}, []);
	const refreshNotificationsFeed = () =>
		store.dispatch(NotificationFeedActionCreators.getNotificationFeed());
	return (
		<ZViewOpportunityRequestModal
			visible={!!viewOpportunityRequestModalId}
			onCancelViewOpportunityRequestModal={onClose}
			pendingOpportunityId={viewOpportunityRequestModalId ?? ""}
			getPendingOpportunity={
				getPendingOpportunitySharedWithPartnerRequest
			}
			checkConflictForPendingOpportunity={
				checkConflictForPendingOpportunityShareWithPartner
			}
			acceptPendingOpportunity={acceptPendingOpportunityRequest}
			rejectPendingOpportunity={rejectPendingOpportunityRequest}
			createClient={createClient}
		/>
	);
};

export default PendingOpportunitiesModal;
